import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DocumentPagesAPI from '../AddDocumentAPI/DocumentPagesAPI';
import ContentMask from './ContentMask/ContentMask';
import Tray from './Tray/Tray';
import {isMobile} from 'react-device-detect';
import TranslatedContentAPI from './TranslatedContent/TranslatedContentAPI';
import { useSession } from '../../common/session/SessionContext';
import BrandedContentAPI from './Content/BrandedContent/BrandedContentAPI';
import UploadAPI from '../UploadAPI/UploadAPI';
import BodyAPI from './Content/BodyAPI/BodyAPI';

const HomeAPI = () => {
  
  const { activeDocument, updateContextId  } = useSession();
  const [openTrayEditDocument, setOpenTrayEditDocument] = useState(false);
  const location = useLocation();

  const openTray = () => {
    setOpenTrayEditDocument(true);
  };

  const closeTray = () => {
    setOpenTrayEditDocument(false);
  };

  useEffect(() => {
    let query = new URLSearchParams(location.search);
    let contextIdFromUrl = query.get('ContextId');
    updateContextId(contextIdFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TranslatedContentAPI>
        <BrandedContentAPI>
        <BodyAPI>
              <aps-app-body class="page page-upload" >
                <UploadAPI openTray={openTray}/>
              </aps-app-body>
        </BodyAPI>
      </BrandedContentAPI>
      <Tray
        isTrayOpen={openTrayEditDocument}
        closeTray={closeTray}
      >
        {/*
          The openTrayEditDocument state variable will already hide this by hiding the tray.
          But if we do not control rendering the DocumentPages component with this condition,
          then its state is preserved and clicking 'Cancel' to hide the tray will not undo any
          state changes that took place within the component.
        */}
        
        {openTrayEditDocument &&
        <DocumentPagesAPI
          document={activeDocument}
          isMobile={isMobile}
          headerTitleAlign="center"
          headerTitleSize="small"
          onFinish={closeTray}
          onCancel={closeTray}
        />
        }
      </Tray>
      <ContentMask
        isTrayOpen={openTrayEditDocument}
        closeTray={closeTray}
      />
    </TranslatedContentAPI>
  );
};

export default HomeAPI;